import { Injectable } from '@angular/core';
import { CompanyService } from './company.service';
import { BookingProfileService } from './booking-profile.service';
import { ResourceService } from './resource.service';
import { Observable, combineLatest, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CompanyProgressService {

  companyProgress$: Observable<number>;

  group1 = 0; group1size = 3;
  hasCompanyName!: boolean;
  hasCompanyEmail!: boolean;
  hasCompanyAddress!: boolean;

  group2 = 0; group2size = 2;
  hasCompanyEmployee!: boolean;
  hasService!: boolean;
  hasBookingProfile!: boolean;

  group3 = 0; group3size = 2;
  hasPlan!: boolean;
  isBookable!: boolean;

  constructor(
    public companyService: CompanyService,
    private bookingProfileService: BookingProfileService,
    private resourceService: ResourceService,
  ) {
    this.companyProgress$ = combineLatest(
      this.companyService.company,
      this.companyService.companyBilling,
      this.companyService.services,
      this.bookingProfileService.companyBookingProfiles,
      this.resourceService.companyEmployees,
    ).pipe(
      switchMap(([company, billing, services, bookingProfiles, employees]) => {
        this.group1 = 0; this.group2 = 0; this.group3 = 0;
        // Group1
        if (company && company.name && company.name.length) {
          this.hasCompanyName = true;
          this.group1++;
        }
        if (company && company.email && company.email.length) {
          this.hasCompanyEmail = true;
          this.group1++;
        }
        if (company && company.address && company.address.street && company.address.street.length) {
          this.hasCompanyAddress = true;
          this.group1++;
        }

        // Group2
        if (employees && employees.length > 1) {
          this.hasCompanyEmployee = true;
          this.group2++;
        }
        if (services && services.length) {
          this.hasService = true;
          this.group2++;
        }
        if (bookingProfiles && bookingProfiles.length) {
          this.hasBookingProfile = true;
          this.group2++;
        }

        // Group3
        if (billing && (billing.flex || billing.fix)) {
          this.hasPlan = true;
          this.group3++;
        }
        if (company && company.bookable) {
          this.isBookable = true;
          this.group3++;
        }

        const total = this.group1size + this.group2size + this.group3size;
        const curr = this.group1 + this.group2 + this.group3;
        const prog = Math.floor(curr / total * 100);

        return of(prog > 0 ? prog : company ? 1 : 0);
      })
    );
  }
}
